import * as React from 'react';
import { Section } from '../Section';
import { Availability } from './Availability';
import { ClosedArea } from './ClosedArea';
import { Demurrage } from './Demurrage';

export const Pickup: React.FC = () => {
  return (
    <Section title="Pickup filters">
      <div className="space-y-6">
        <Availability />
        <ClosedArea />
        <Demurrage />
      </div>
    </Section>
  );
};
Pickup.displayName = 'Filters.More.Pickup';
